var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('commonHeader',{attrs:{"title":"帮助文档"}}),_c('div',{staticClass:"common_contentBox"},[_c('commonTable',{ref:"helpDocumentation"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }